export default "__VITE_ASSET__BdjFsiqg__"